/**
 * Универсальное подтверждение команды поверх всего интерфейса. Без `actions` кнопки
 * рисует содержимое — например, форма со своей кнопкой отправки.
 */
import type { ReactNode } from "react";
import { Modal } from "./Modal";
import { Text } from "./Text";

type ConfirmModalProps = {
	actions?: ReactNode;
	children?: ReactNode;
	description: ReactNode;
	onClose: () => void;
	title: string;
};

export const ConfirmModal = ({
	actions,
	children,
	description,
	onClose,
	title,
}: ConfirmModalProps) => {
	return (
		<Modal ariaLabel={title} className="p-5 md:max-w-sm" onClose={onClose}>
			<Text size="xl">{title}</Text>
			<Text as="p" className="mt-3 text-sm text-ink">
				{description}
			</Text>
			{children}
			{actions && <div className="mt-5 flex justify-end gap-2">{actions}</div>}
		</Modal>
	);
};
